(() => {
  const initializeCheckout = (root) => {
    const checkout = root.matches?.('[data-gs-secure-checkout]')
      ? root
      : root.querySelector?.('[data-gs-secure-checkout]');

    if (!checkout || checkout.dataset.gsCheckoutReady === 'true') return;
    checkout.dataset.gsCheckoutReady = 'true';

    const form = checkout.querySelector('#gs-cart-form');
    if (!form) return;

    const updateStatus = checkout.querySelector('[data-gs-update-status]');
    const updateButton = checkout.querySelector('.gs-checkout__update');
    const handoff = checkout.querySelector('[data-gs-checkout-handoff]');
    const mobileCheckout = checkout.querySelector('[data-gs-mobile-checkout]');
    const primaryCheckout = checkout.querySelector('.gs-checkout-summary__button');
    let handoffTimer;

    const markCartChanged = () => {
      checkout.classList.add('gs-cart-is-dirty');
      if (updateStatus) updateStatus.hidden = false;
      updateButton?.setAttribute('aria-label', 'Update bag and recalculate total');
    };

    checkout.querySelectorAll('[data-gs-quantity]').forEach((quantity) => {
      const input = quantity.querySelector('[data-gs-quantity-input]');
      if (!input) return;

      quantity.querySelectorAll('[data-gs-quantity-change]').forEach((button) => {
        button.addEventListener('click', () => {
          const current = Number.parseInt(input.value, 10) || 0;
          const minimum = Number.parseInt(input.min, 10) || 0;
          const change = Number.parseInt(button.dataset.gsQuantityChange, 10) || 0;
          input.value = Math.max(minimum, current + change);
          input.dispatchEvent(new Event('change', { bubbles: true }));
          input.focus({ preventScroll: true });
        });
      });

      input.addEventListener('change', markCartChanged);
      input.addEventListener('input', markCartChanged);
    });

    const resetHandoff = () => {
      window.clearTimeout(handoffTimer);
      checkout.classList.remove('gs-is-handing-off');
      document.documentElement.classList.remove('gs-checkout-lock');
      handoff?.setAttribute('aria-hidden', 'true');
    };

    form.addEventListener('submit', (event) => {
      if (event.submitter?.name !== 'checkout') return;

      checkout.classList.add('gs-is-handing-off');
      document.documentElement.classList.add('gs-checkout-lock');
      handoff?.setAttribute('aria-hidden', 'false');
      handoffTimer = window.setTimeout(resetHandoff, 8000);
    });

    if (mobileCheckout && primaryCheckout && 'IntersectionObserver' in window) {
      const checkoutObserver = new IntersectionObserver(([entry]) => {
        mobileCheckout.classList.toggle('gs-mobile-checkout--hidden', entry.isIntersecting);
      }, { threshold: 0.25 });
      checkoutObserver.observe(primaryCheckout);
    }

    window.addEventListener('pageshow', resetHandoff);
  };

  initializeCheckout(document);
  document.addEventListener('shopify:section:load', (event) => initializeCheckout(event.target));
})();
